import {useFormik} from 'formik';
import {useState} from 'react';
import * as Yup from 'yup';
import {useI18n} from '../../common/providers/I18nProvider';
import {HttpError} from '../../common/hooks/ApiClient';
import {useAuthedMutation} from '../../common/hooks/QueryHooks';
import {Content} from './Content';

const useHelp = () => {
	const {i18n} = useI18n();
	const [loading, setLoading] = useState(false);
	const {mutate} = useAuthedMutation<Content>(`enterpriser/profile/contact-us`);
	const [success, setShowSuccess] = useState(false);
	const [formKey, setFormKey] = useState(1);

	const registerSchema = Yup.object().shape({
		typeOfInquiry: Yup.string().required('Name is required'),
		inquiryContent: Yup.string().required(i18n('HELP.MESSAGE')),
	});

	const formik = useFormik({
		initialValues: {
			typeOfInquiry: undefined,
			inquiryContent: undefined,
		},
		validationSchema: registerSchema,
		onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
			console.log(values);

			setLoading(true);
			try {
				const data = {...values};
				await mutate({data});

				setFormKey((prevKey) => prevKey + 1);
				setShowSuccess(true);
				resetForm();
			} catch (error) {
				if (error instanceof HttpError) {
					setStatus(error.message);
				}
			} finally {
				setSubmitting(false);
				setLoading(false);
			}
		},
	});
	const nameIsInValid = formik.touched.typeOfInquiry && formik.errors.typeOfInquiry;
	const messageIsInValid = formik.touched.inquiryContent && formik.errors.inquiryContent;
	const isAnyFieldTouched = formik.touched.inquiryContent || formik.touched.typeOfInquiry;
	const canSubmit = isAnyFieldTouched && formik.isValid;

	const canNotSubmit = formik.isSubmitting || !canSubmit;

	return {
		loading,
		formik,
		nameIsInValid,
		messageIsInValid,
		canNotSubmit,
		success,
		setShowSuccess,
		formKey,
	};
};

export default useHelp;
